import {
    SUBMIT_GET_LIVE_ACCOUNTS_REQUEST,
    SUBMIT_GET_LIVE_ACCOUNTS_SUCCESS,
    SUBMIT_GET_LIVE_ACCOUNTS_FAILURE,
} from "../actions/fetchLiveAccountsActions";

const initialState = {
  loadData: false,
  successData: "",
  errorData: "",
};

export const getLiveAccountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_GET_LIVE_ACCOUNTS_REQUEST:
      return { ...state, loadData: true, successData: "", errorData: "" };
    case SUBMIT_GET_LIVE_ACCOUNTS_SUCCESS:
      return { ...state, loadData: false, successData: action.payload };
    case SUBMIT_GET_LIVE_ACCOUNTS_FAILURE:
      return { ...state, loadData: false, errorData: action.payload };
    default:
      return state;
  }
};